import { SPACE, THEME } from '@HoudiniUI/Theme/theme';
import { StyleSheet } from 'aphrodite';

export const filevineColor = '#161110';

const filevineColorTranslucent = `${filevineColor}1b`;

export const styleSheet = StyleSheet.create({
	ctaButton: {
		background: filevineColorTranslucent,
		border: 'none',
		boxShadow: 'none',
		color: filevineColor,
		fontWeight: THEME.typography.fontWeights.standard,
		marginTop: SPACE[20],
	},
	integrationTitle: {
		color: filevineColor,
	},
	logo: {
		border: `1px solid ${filevineColor}`,
		borderRadius: THEME.common.borderRadius,
		height: 40,
		marginRight: -SPACE[8],
		objectFit: 'contain',
		padding: SPACE[4],
		width: 40,
	},
});
